import VideoSectionPage from '../components/VideoSectionPage';

const SECTIONS_MOTIVATION = [
  { key: 'byMotivation', label: 'LES LUNDIS DE LA MOTIVATION PAR ANNÉE', renderKey: 'byYear' },
  { key: 'byMotivationTheme', label: 'LES LUNDIS DE LA MOTIVATION PAR THÈME', renderKey: 'byTheme' },
];

export default function MotivationPage() {
  return (
    <VideoSectionPage
      section="motivation_lundi"
      sidebarLabel="LES LUNDIS DE LA MOTIVATION"
      renderKey="byYear"
      videoTitlePrefix={null}
      showThemeFilter={true}
      extraSections={SECTIONS_MOTIVATION}
    />
  );
} 
